export const SET_USER_DETAIL = "SET_USER_DETAIL";
export const GET_CHILD_DROPDOWN_OPTION = "GET_CHILD_DROPDOWN_OPTION";
export const TOGGEL_SIDEBAR = "TOGGEL_SIDEBAR";
export const GET_PAGE_RELOAD_FLAG = "GET_PAGE_RELOAD_FLAG";
export const ASSIGN_VALUE = "ASSIGN_VALUE";
export const ALERT_COMPONENT = "ALERT_COMPONENT";
export const BASIC_AUTH = "BASIC_AUTH";
export const FORM_VALUES = "FORM_VALUES";
export const REGISTRATION_RESPONSE_SAVE = 'REGISTRATION_RESPONSE_SAVE'
export const TAB_HIDE_VALUES = 'TAB_HIDE_VALUES'
export const SELECTED_TAB = 'SELECTED_TAB'
export const WORKFLOW_FLAG = 'WORKFLOW_FLAG'
export const RELATIONTYPE = 'RELATIONTYPE'
export const SET_LOGIN = 'SET_LOGIN'
export const GET_USERROLES = 'GET_USERROLES'
export const SET_LOGGEDIN_USER_ROLE = 'SET_LOGGEDIN_USER_ROLE'
export const SET_LANGUAGE_LIST = 'SET_LANGUAGE_LIST'


